<template>
  <p v-if="alignedGoal" class="text-muted">
    Aligned to goal:
    <router-link
      :to="getGoalRouterLink(alignedGoal)"
      target="_blank"
      @click.native="sendOpenedGoalLinkEvent(alignedGoal)">
      {{ alignedGoal.title }}
      <OpensInNewTabIcon />
    </router-link>
  </p>
  <p v-else class="text-muted">
    Found In:
    <ul>
      <li v-for="strategy in alignedContent.strategies" :key="strategy.uuid">
        <router-link :to="{name: 'StrategyDetailPage', params: {slugOrUuid: strategy.slug}}">
          <span>Strategy: {{ strategy.title }}</span>
        </router-link>
      </li>
      <li v-for="skill in alignedSkillList" :key="skill.uuid">
        Present Levels Area: {{ skill.subject }} - {{ skill.name }} {{ getLevelTitlesString(skill.levelTitles) }}
      </li>
    </ul>
  </p>
</template>

<script>
import { addSpacesToTitleCaseString } from '@/util/string_manipulation.js'
import OpensInNewTabIcon from '@/components/OpensInNewTabIcon.vue'
export default {
  name: 'ResourceFoundIn',
  components: { OpensInNewTabIcon },
  props: {
    alignedContent: {
      type: Object,
      required: true
    }
  },
  computed: {
    alignedGoal() {
      if (!this.alignedContent.goals || !this.alignedContent.goals.length) {
        return null
      }
      return this.alignedContent.goals[0]
    },
    uniqueGoals() {
      if (!this.alignedContent.goals) {
        return []
      }
      let alignedGoalsByUUID = {}
      for (let i in this.alignedContent.goals) {
        let goal = this.alignedContent.goals[i]
        // filter out additional objective alignments for the same goal:
        if (!alignedGoalsByUUID[goal.uuid]) {
          alignedGoalsByUUID[goal.uuid] = goal
        }
      }
      return Object.keys(alignedGoalsByUUID).map(key => alignedGoalsByUUID[key])
    },
    alignedSkillList() {
      let alignedSkillsByUUID = {}
      for (let i in this.alignedContent.present_levels_skills) {
        let skill = this.alignedContent.present_levels_skills[i]
        if (alignedSkillsByUUID[skill.skill_uuid]) {
          alignedSkillsByUUID[skill.skill_uuid].levelTitles.push(skill.level_title)
        } else {
          alignedSkillsByUUID[skill.skill_uuid] = {
            name: skill.skill_name,
            subject: addSpacesToTitleCaseString(skill.plw_subject),
            levelTitles: [skill.level_title]
          }
        }
      }
      return alignedSkillsByUUID
    },
  },
  methods: {
    getLevelTitlesString(levelTitlesArray) {
      return levelTitlesArray.length && levelTitlesArray.length <= 3 && `(${levelTitlesArray.join(', ')})`
    },
    getGoalRouterLink(goal) {
      if (goal.super_page) {
        return {name: 'AnchorPage', params: { uuid: goal.uuid } }
      }
      return {name: 'GoalContentPage', params: { slug: goal.slug }}
    },
    sendOpenedGoalLinkEvent(goal) {
      this.$sendEvent('Opened Aligned Goal Link', {
        aligned_goal_title: goal.title,
        aligned_goal_uuid: goal.uuid
      })
    }
  }
}
</script>

<style>
p {
  padding-bottom: var(--spacing-xs);
  margin-bottom: 0;
}
</style>
